import { TagVariant } from '../components/tag';

export type PromotionTypes = 'in_store' | 'coupon';
export const PromotionTypes = ['in_store', 'coupon'] as const;
export const PromotionTypesRegEx = /in_store|coupon/;

export type PromotionStatuses =
    | 'upcoming'
    | 'activatable'
    | 'expired'
    | 'ended';
export const PromotionStatuses = [
    'upcoming',
    'activatable',
    'expired',
    'ended',
] as const;

export const TEN_PER_PAGE = 10;

export type FeaturedTypes =
    | 'promotion'
    | 'external_url'
    | 'promotions/in_store'
    | 'promotions/coupons'
    | 'stores'
    | 'ct-connect'
    | 'car-wash'
    | 'games';
export const FeaturedTypes = [
    'promotion',
    'external_url',
    'promotions/in_store',
    'promotions/coupons',
    'stores',
    'ct-connect',
    'car-wash',
    'games',
] as const;

export const LegacyFeaturedTypes = [
    'promotions/in_store',
    'promotions/coupons',
    'stores',
    'ct-connect',
    'car-wash',
] as const;

export type FeedbackTypes = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export const FeedbackTypes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const;

export const FeaturedTypesRegEx = /promotion|external_url|promotions\/in_store|promotion\/coupons|stores|ct-connect|car-wash|games/;

export const isLegacyFeaturedType = (type: FeaturedTypes): boolean =>
    LegacyFeaturedTypes.includes(type as typeof LegacyFeaturedTypes[number]);

export const FeatureTypeTagVariants: {
    [key in FeaturedTypes]: TagVariant;
} = {
    promotion: 'magenta',
    external_url: 'error',
    'promotions/in_store': 'orange',
    'promotions/coupons': 'lime',
    stores: 'blue',
    'ct-connect': 'blue',
    'car-wash': 'purple',
    games: 'success',
};

export const FeedbackTypeTagVariants: { [key in FeedbackTypes]: TagVariant } = {
    0: 'error',
    1: 'error',
    2: 'error',
    3: 'error',
    4: 'error',
    5: 'error',
    6: 'error',
    7: 'orange',
    8: 'orange',
    9: 'success',
    10: 'success',
};

export const GameTypeTagVariants: Record<string, TagVariant> = {
    labatt: 'brand-blue',
    six12: 'orange',
    external: 'purple',
};

export type ActiveQueryParam = 'active' | 'inactive';
export const ActiveQueryParam = ['active', 'inactive'] as const;

export type AnalyticsCompareOptions = 'preceding' | 'yearly' | 'custom';

export const ANALYTICS_DEFAULT_DATE_RANGE = 28;
export const ANALYTICS_DEFAULT_COMPARE_OPTION: AnalyticsCompareOptions =
    'preceding';

export type RANGE_PROPERTIES = 'current' | 'compare' | undefined;

export const CMS_HISTORY_ACTIONS = [
    'create',
    'update',
    'delete',
    'upload-pins',
    'reissue-coupon',
    'reset-password',
    'validate-phone-number',
    'validate-email',
    'complete-onboarding',
    'sort-order',
    'restart-onboarding',
] as const;

export type CmsHistoryAction = typeof CMS_HISTORY_ACTIONS[number];

export const CMS_HISTORY_ACTION_LABELS: Record<CmsHistoryAction, string> = {
    create: 'Create',
    update: 'Update',
    delete: 'Delete',
    'upload-pins': 'Upload Pins',
    'reissue-coupon': 'Reissue Coupon',
    'reset-password': 'Reset Password',
    'validate-phone-number': 'Validate Phone Number',
    'validate-email': 'Validate Email',
    'complete-onboarding': 'Complete Onboarding',
    'sort-order': 'Sort Order',
    'restart-onboarding': 'Restart Onboarding',
};

export function getCmsHistoryActionLabel(
    action: string | undefined | null
): string {
    if (!action) return '';
    return CMS_HISTORY_ACTION_LABELS[action as CmsHistoryAction] || action;
}
